<template>
    <div class="col-6">
        <el-switch :model-value="switchValue" :disabled="!isEditable" :active-text="activeText" style="width: 100%;"
            @change="$emit('update:switchValue', $event)" />
        <div class="form-floating mb-3 position-relative" v-show="switchValue">
            <img class="position-absolute top-50 start-0 translate-middle-y ps-3" :src="iconSrc" alt="Ícone"
                width="40px" style="z-index: 9;">
            <input 
                inputmode="numeric" 
                :disabled="!isEditable" 
                :value="dateValue" 
                type="tel"
                :class="['form-control ps-5', { 'error-border': errors.length > 0 }]"
                required
                @input="onInput" 
                :placeholder="placeholder" 
                maxlength="10" 
                style="height: 66px; border-radius: .75rem;"
            >
            <label :for="inputId" class="ps-5">{{ label }}</label>
        </div>

<p v-if="errors && errors.length" class="text-danger error">{{ errors[0] }}</p>

    </div>
</template>

<script>
export default {
    name: 'SwitchDateInput',
    props: {
        switchValue: { type: Boolean, required: true },
        dateValue: { type: String, required: true },
        isEditable: { type: Boolean, default: true },
        errors: { type: Array, default: () => [] },
        activeText: { type: String, default: 'Em Andamento' },
        label: { type: String, default: 'Matrícula' },
        placeholder: { type: String, default: 'Data de Matrícula' },
        inputId: { type: String, default: 'ebd_inicio_data' },
        iconSrc: { type: String, default: 'https://img.icons8.com/?size=100&id=85102&format=png&color=B0B2B3' },
    },
    methods: {
        formatarData(valor) {
            valor = valor.replace(/\D/g, '')
            if (valor.length > 2) valor = valor.slice(0, 2) + '/' + valor.slice(2)
            if (valor.length > 5) valor = valor.slice(0, 5) + '/' + valor.slice(5, 9)
            return valor
        },
        onInput(event) {
            const valorFormatado = this.formatarData(event.target.value)
            this.$emit('update:dateValue', valorFormatado)
        }
    }
}
</script>

<style scoped>
.error-border {
    border: 1px solid red !important;
    border-radius: 0.75rem !important;
}

.text-danger {
    width: 100%;
    text-align: left;
    padding: 5px;
}

.form-floating input {
    padding-left: 43px !important;
    /* Espaço para o ícone */
}

.form-floating img {
    z-index: 9;
    /* Ícone acima do input */
}
</style>
